(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7166],{

/***/ 38415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(99958);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ 50863:
/***/ (function(module) {

var valueOf = 1.0.valueOf;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = function (value) {
  return valueOf.call(value);
};


/***/ }),

/***/ 56977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var toInteger = __webpack_require__(99958);
var thisNumberValue = __webpack_require__(50863);
var repeat = __webpack_require__(38415);
var fails = __webpack_require__(47293);

var nativeToFixed = 1.0.toFixed;
var floor = Math.floor;

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat.call('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = nativeToFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !fails(function () {
  // V8 ~ Android 4.3-
  nativeToFixed.call({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toInteger(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat.call('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat.call('0', fractDigits - k) + result
        : result.slice(0, k - fractDigits) + '.' + result.slice(k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ 97166:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gn": function() { return /* binding */ centsToCurrencyString; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* unused harmony exports centsToPrettyCurrencyString, fractionToPercentString */
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_number_to_fixed_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56977);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_parse_float_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54678);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15306);
function cov_825wybjq6() {
  var path = "/__w/code/code/js/packages/bricks/src/helpers/currencyHelpers.ts";
  var hash = "1a9641ee5d61af56a67aeab2bff6826a525a6b8d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/helpers/currencyHelpers.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 30
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 2,
          column: 24
        },
        end: {
          line: 2,
          column: 44
        }
      },
      "2": {
        start: {
          line: 3,
          column: 20
        },
        end: {
          line: 3,
          column: 62
        }
      },
      "3": {
        start: {
          line: 4,
          column: 18
        },
        end: {
          line: 4,
          column: 62
        }
      },
      "4": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 9,
          column: 58
        }
      },
      "5": {
        start: {
          line: 12,
          column: 37
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "6": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 56
        }
      },
      "7": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 19,
          column: 15
        }
      },
      "8": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 19,
          column: 15
        }
      },
      "9": {
        start: {
          line: 24,
          column: 25
        },
        end: {
          line: 24,
          column: 53
        }
      },
      "10": {
        start: {
          line: 25,
          column: 24
        },
        end: {
          line: 25,
          column: 48
        }
      },
      "11": {
        start: {
          line: 26,
          column: 23
        },
        end: {
          line: 26,
          column: 48
        }
      },
      "12": {
        start: {
          line: 27,
          column: 21
        },
        end: {
          line: 27,
          column: 51
        }
      },
      "13": {
        start: {
          line: 28,
          column: 21
        },
        end: {
          line: 28,
          column: 47
        }
      },
      "14": {
        start: {
          line: 29,
          column: 22
        },
        end: {
          line: 29,
          column: 43
        }
      },
      "15": {
        start: {
          line: 30,
          column: 17
        },
        end: {
          line: 30,
          column: 77
        }
      },
      "16": {
        start: {
          line: 32,
          column: 24
        },
        end: {
          line: 32,
          column: 42
        }
      },
      "17": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 39,
          column: 3
        }
      },
      "18": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 68
        }
      },
      "19": {
        start: {
          line: 35,
          column: 9
        },
        end: {
          line: 39,
          column: 3
        }
      },
      "20": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 65
        }
      },
      "21": {
        start: {
          line: 37,
          column: 9
        },
        end: {
          line: 39,
          column: 3
        }
      },
      "22": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 74
        }
      },
      "23": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 41,
          column: 73
        }
      },
      "24": {
        start: {
          line: 48,
          column: 39
        },
        end: {
          line: 57,
          column: 26
        }
      },
      "25": {
        start: {
          line: 53,
          column: 2
        },
        end: {
          line: 57,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 1,
            column: 30
          },
          end: {
            line: 1,
            column: 31
          }
        },
        loc: {
          start: {
            line: 1,
            column: 84
          },
          end: {
            line: 10,
            column: 1
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 12,
            column: 37
          },
          end: {
            line: 12,
            column: 38
          }
        },
        loc: {
          start: {
            line: 12,
            column: 83
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 12
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 18
          },
          end: {
            line: 16,
            column: 19
          }
        },
        loc: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 19,
            column: 15
          }
        },
        line: 17
      },
      "3": {
        name: "centsToPrettyCurrencyString",
        decl: {
          start: {
            line: 23,
            column: 16
          },
          end: {
            line: 23,
            column: 43
          }
        },
        loc: {
          start: {
            line: 23,
            column: 87
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 23
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 48,
            column: 39
          },
          end: {
            line: 48,
            column: 40
          }
        },
        loc: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 57,
            column: 26
          }
        },
        line: 53
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 1,
            column: 51
          },
          end: {
            line: 1,
            column: 71
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 1,
            column: 66
          },
          end: {
            line: 1,
            column: 71
          }
        }],
        line: 1
      },
      "1": {
        loc: {
          start: {
            line: 2,
            column: 24
          },
          end: {
            line: 2,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 2,
            column: 39
          },
          end: {
            line: 2,
            column: 40
          }
        }, {
          start: {
            line: 2,
            column: 43
          },
          end: {
            line: 2,
            column: 44
          }
        }],
        line: 2
      },
      "2": {
        loc: {
          start: {
            line: 9,
            column: 12
          },
          end: {
            line: 9,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 9,
            column: 37
          },
          end: {
            line: 9,
            column: 38
          }
        }, {
          start: {
            line: 9,
            column: 41
          },
          end: {
            line: 9,
            column: 56
          }
        }],
        line: 9
      },
      "3": {
        loc: {
          start: {
            line: 12,
            column: 58
          },
          end: {
            line: 12,
            column: 78
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 12,
            column: 73
          },
          end: {
            line: 12,
            column: 78
          }
        }],
        line: 12
      },
      "4": {
        loc: {
          start: {
            line: 18,
            column: 27
          },
          end: {
            line: 18,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 44
          },
          end: {
            line: 18,
            column: 45
          }
        }, {
          start: {
            line: 18,
            column: 48
          },
          end: {
            line: 18,
            column: 49
          }
        }],
        line: 18
      },
      "5": {
        loc: {
          start: {
            line: 23,
            column: 64
          },
          end: {
            line: 23,
            column: 85
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 23,
            column: 81
          },
          end: {
            line: 23,
            column: 85
          }
        }],
        line: 23
      },
      "6": {
        loc: {
          start: {
            line: 26,
            column: 23
          },
          end: {
            line: 26,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 26,
            column: 40
          },
          end: {
            line: 26,
            column: 43
          }
        }, {
          start: {
            line: 26,
            column: 46
          },
          end: {
            line: 26,
            column: 48
          }
        }],
        line: 26
      },
      "7": {
        loc: {
          start: {
            line: 30,
            column: 17
          },
          end: {
            line: 30,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 33
          }
        }, {
          start: {
            line: 30,
            column: 36
          },
          end: {
            line: 30,
            column: 77
          }
        }],
        line: 30
      },
      "8": {
        loc: {
          start: {
            line: 30,
            column: 36
          },
          end: {
            line: 30,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 30,
            column: 49
          },
          end: {
            line: 30,
            column: 52
          }
        }, {
          start: {
            line: 30,
            column: 55
          },
          end: {
            line: 30,
            column: 77
          }
        }],
        line: 30
      },
      "9": {
        loc: {
          start: {
            line: 30,
            column: 55
          },
          end: {
            line: 30,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 30,
            column: 69
          },
          end: {
            line: 30,
            column: 72
          }
        }, {
          start: {
            line: 30,
            column: 75
          },
          end: {
            line: 30,
            column: 77
          }
        }],
        line: 30
      },
      "10": {
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 39,
            column: 3
          }
        }],
        line: 33
      },
      "11": {
        loc: {
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 39,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 9
          },
          end: {
            line: 39,
            column: 3
          }
        }, {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 39,
            column: 3
          }
        }],
        line: 35
      },
      "12": {
        loc: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 39,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 39,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 37
      },
      "13": {
        loc: {
          start: {
            line: 41,
            column: 27
          },
          end: {
            line: 41,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 41,
            column: 44
          },
          end: {
            line: 41,
            column: 47
          }
        }, {
          start: {
            line: 41,
            column: 50
          },
          end: {
            line: 41,
            column: 52
          }
        }],
        line: 41
      },
      "14": {
        loc: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 50,
            column: 26
          },
          end: {
            line: 50,
            column: 27
          }
        }],
        line: 50
      },
      "15": {
        loc: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 51,
            column: 26
          },
          end: {
            line: 51,
            column: 27
          }
        }],
        line: 51
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0],
      "15": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1a9641ee5d61af56a67aeab2bff6826a525a6b8d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_825wybjq6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_825wybjq6();








cov_825wybjq6().s[0]++;
var formatCurrency = function formatCurrency(centsValue) {
  var roundToCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_825wybjq6().b[0][0]++, false);
  cov_825wybjq6().f[0]++;
  var decimalPlaces = (cov_825wybjq6().s[1]++, roundToCents ? (cov_825wybjq6().b[1][0]++, 2) : (cov_825wybjq6().b[1][1]++, 0));
  var parsedNum = (cov_825wybjq6().s[2]++, centsValue.toString().replace(/\$|,/g, ''));
  var rounded = (cov_825wybjq6().s[3]++, parseFloat(parsedNum).toFixed(decimalPlaces));
  cov_825wybjq6().s[4]++;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(Number(rounded)) ? (cov_825wybjq6().b[2][0]++, 0) : (cov_825wybjq6().b[2][1]++, Number(rounded)));
};
cov_825wybjq6().s[5]++;
var centsToCurrencyString = function centsToCurrencyString(valueCents) {
  var roundToCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_825wybjq6().b[3][0]++, false);
  cov_825wybjq6().f[1]++;
  cov_825wybjq6().s[6]++;
  return formatCurrency(valueCents / 100, roundToCents);
};
cov_825wybjq6().s[7]++;
var addSuffix = function addSuffix(dollars, suffix) {
  cov_825wybjq6().f[2]++;
  cov_825wybjq6().s[8]++;
  return "".concat(dollars.toLocaleString('en-US', {
    maximumFractionDigits: suffix === 'k' ? (cov_825wybjq6().b[4][0]++, 0) : (cov_825wybjq6().b[4][1]++, 1)
  })).concat(suffix);
};

// converts currency cents from 24000000 to 240K, 240000000 to 2.4M and
// aspirationally will also handle billions correctly
function centsToPrettyCurrencyString(valueCents) {
  var showDollarSign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_825wybjq6().b[5][0]++, true);
  cov_825wybjq6().f[3]++;
  var valueInDollars = (cov_825wybjq6().s[9]++, Math.round(valueCents / 100));
  var absoluteValue = (cov_825wybjq6().s[10]++, Math.abs(valueInDollars));
  var showNegative = (cov_825wybjq6().s[11]++, valueCents < 0 ? (cov_825wybjq6().b[6][0]++, '-') : (cov_825wybjq6().b[6][1]++, ''));
  var isBillions = (cov_825wybjq6().s[12]++, absoluteValue >= 1000000000);
  var isMillions = (cov_825wybjq6().s[13]++, absoluteValue >= 1000000);
  var isThousands = (cov_825wybjq6().s[14]++, absoluteValue >= 1000);
  var suffix = (cov_825wybjq6().s[15]++, isBillions ? (cov_825wybjq6().b[7][0]++, 'B') : (cov_825wybjq6().b[7][1]++, isMillions ? (cov_825wybjq6().b[8][0]++, 'M') : (cov_825wybjq6().b[8][1]++, isThousands ? (cov_825wybjq6().b[9][0]++, 'k') : (cov_825wybjq6().b[9][1]++, ''))));
  var formattedString = (cov_825wybjq6().s[16]++, "".concat(absoluteValue));
  cov_825wybjq6().s[17]++;
  if (isBillions) {
    cov_825wybjq6().b[10][0]++;
    cov_825wybjq6().s[18]++;
    formattedString = addSuffix(absoluteValue / 1000000000, suffix);
  } else {
    cov_825wybjq6().b[10][1]++;
    cov_825wybjq6().s[19]++;
    if (isMillions) {
      cov_825wybjq6().b[11][0]++;
      cov_825wybjq6().s[20]++;
      formattedString = addSuffix(absoluteValue / 1000000, suffix);
    } else {
      cov_825wybjq6().b[11][1]++;
      cov_825wybjq6().s[21]++;
      if (isThousands) {
        cov_825wybjq6().b[12][0]++;
        cov_825wybjq6().s[22]++;
        formattedString = addSuffix(Math.round(absoluteValue / 1000), suffix);
      } else {
        cov_825wybjq6().b[12][1]++;
      }
    }
  }
  cov_825wybjq6().s[23]++;
  return "".concat(showNegative).concat(showDollarSign ? (cov_825wybjq6().b[13][0]++, '$') : (cov_825wybjq6().b[13][1]++, '')).concat(formattedString);
}

/*
TODO: Migrate to use Intl.NumberFormat once typescript is updated
https://v8.dev/features/intl-numberformat#sign
*/
cov_825wybjq6().s[24]++;
var fractionToPercentString = function fractionToPercentString(valueFraction) {
  var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_825wybjq6().b[14][0]++, 1);
  var minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_825wybjq6().b[15][0]++, 0);
  cov_825wybjq6().f[4]++;
  cov_825wybjq6().s[25]++;
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits,
    style: 'percent'
  }).format(valueFraction);
};

/***/ })

}]);